<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 bg-gradient-primary shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-4">
                <card
                  class="border-0 d-flex card-bphtb"
                  hover
                  shadow
                  body-classes="text-center align-items-center d-flex justify-content-center"
                >
                  <object
                    data="/img/svg/10-BPHTB.svg"
                    type="image/svg+xml"
                    class="text-white card-pajak"
                  ></object>
                  <h6
                    class="text-white text-uppercase title-inside-card"
                    style="margin-top: 7px"
                  >BPHTB</h6>
                </card>
              </div>
              <div class="col-lg-8">
                <h1 class="display-3 text-white">
                  Pelayanan BPHTB
                  <span>Kota Tarakan</span>
                </h1>
                <p
                  class="description mt-3 text-white"
                >Bea Perolehan Hak atas Tanah dan Bangunan atau BPHTB diatur dalam UU No. 21 Tahun 1997 dan telah diubah dengan UU No. 20 Tahun 2000 (selanjutnya hanya disebut UU BPHTB). Disebutkan bahwa BPHTB adalah bea yang dikenakan atas perolehan hak atas tanah dan atau bangunan.</p>

                <p
                  class="description mt-3 text-white"
                >Setiap perolehan hak atas tanah dan bangunan, warga negara diwajibkan membayar BPHTB. Dalam bahasa sehari-hari BPHTB juga dikenal sebagai bea pembeli, jika perolehan berdasarkan proses jual beli. Tetapi dalam UU BPHTB, BPHTB dikenakan tidak hanya dalam perolehan berupa jual beli. Semua jenis perolehan hak tanah dan bangunan dikenakan BPHTB.</p>
                <div class="btn-wrapper">
                  <base-button
                    tag="a"
                    class="mb-3 mb-sm-0"
                    type="info"
                    textColor="white"
                    icon="fa fa-arrow-left"
                    @click="goback()"
                  >Kembali</base-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>
    <br>
    <br>
    <section class="section section-lg pt-lg-0 mt--200">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-floppy-o" type="primary" rounded class="mb-4"></icon>
                  <h6 class="text-primary text-uppercase">Daftar</h6>
                  <p class="description mt-3">Daftar Transaksi BPHTB baru.</p>
                  <br>
                  <base-button
                    textColor="white"
                    tag="a"
                    type="primary"
                    class="mt-4"
                    @click="goDaftar()"
                  >List Pendaftaran</base-button>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-floppy-o" type="primary" rounded class="mb-4"></icon>
                  <h6 class="text-primary text-uppercase">Histori Pembayaran</h6>
                  <p class="description mt-3">Cek history pembayaran BPHTB berdasarkan NOP.</p>
                  <base-button
                    textColor="white"
                    tag="a"
                    type="primary"
                    class="mt-4"
                    @click="goObject()"
                  >Cari</base-button>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-print" type="success" rounded class="mb-4"></icon>
                  <h6 class="text-success text-uppercase">Pengajuan Keringanan</h6>
                  <p
                    class="description mt-3"
                  >Mengajukan Keringanan Pembayaran Pajak BPHTB.</p>
                  <base-button
                    textColor="white"
                    tag="a"
                    type="success"
                    class="mt-4"
                    @click="goKeringanan()"
                  >Informasi Pajak</base-button>
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-cog" type="warning" rounded class="mb-4"></icon>
                  <h6 class="text-warning text-uppercase">Cetak SSPD BPHTB</h6>
                  <p
                    class="description mt-3"
                  >Cetak SSPD BPHTB online yang sudah di setujui.</p>
                  <base-button
                    tag="a"
                    textColor="white"
                    type="warning"
                    class="mt-4"
                    @click="goDasarHukum()"
                  >Cetak SSPD</base-button>
                </card>
              </div>
              </div>
            <div class="row row-grid">
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-cog" type="info" rounded class="mb-4"></icon>
                  <h6 class="text-info text-uppercase">Dasar Hukum</h6>
                  <p
                    class="description mt-3"
                  >Dasar Hukum pajak BPHTB.</p>
                  <base-button
                    tag="a"
                    textColor="white"
                    type="info"
                    class="mt-4"
                    @click="goDasarHukum()"
                  >Dasar Hukum</base-button>
                </card>
              </div>
            </div>
          </div>
        </div>

        <br />
        <br />
        <div class="row">
          <div class="col-md-12">
            <highcharts :options="chartOptions"></highcharts>
          </div>
        </div>
      </div>
    </section>

    <br />
    <br />
    <modal-informasi-pajak
      ref="modal-informasi-pajak"
      title="Pencarian Informasi Pajak Bumi dan Bangunan"
      code="1111"
      url="/v1/pajak-daerah/bphtb"
    ></modal-informasi-pajak>
  </div>
</template>

<script>
import ModalInformasiPajak from "../GlobalPage/PajakBPHTB";
import { Chart } from "highcharts-vue";
import Swal from "sweetalert2";
export default {
  name: "pbb",
  components: {
    ModalInformasiPajak,
    highcharts: Chart
  },
  data() {
    return {
      css: CssForBootstrap4,
      items: []
    };
  },
  computed: {
    chartOptions() {
      return {
        chart: {
          type: "column"
        },
        title: {
          text: "Realisasi BPHTB berdasarkan Tahun"
        },
        subtitle: {
          text: "Data tahun yang di ambil adalah data 10 tahun kebelakang."
        },
        accessibility: {
          announceNewData: {
            enabled: true
          }
        },
        xAxis: {
          type: "category"
        },
        yAxis: {
          title: {
            text: "Jumlah Realisasi"
          }
        },
        legend: {
          enabled: false
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: "{point.y:.2f}"
            }
          }
        },

        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat:
            '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>'
        },

        series: [
          {
            name: "Tahun",
            colorByPoint: true,
            data: this.items
          }
        ]
      };
    }
  },
  created() {
    this.getRealisasi();
  },
  methods: {
    async getRealisasi() {
      try {
        this.isBusy = true;
        // let { data } = await axios.get(
        //   "/v1/realisasi-pajak/bphtb"
        // );

        // var items = [];
        // for (const [key, value] of Object.entries(data)) {
        //   this.items.push({
        //     name: value.tahun_realisasi,
        //     y: parseFloat(value.realisasi)
        //   });
        // }
      } catch (error) {
        Swal.fire({
          title: "",
          text: error.message,
          type: "warning",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Tutup!"
        });
      } finally {
        this.isBusy = false;
      }
    },
    goBphtb() {
      this.$refs["modal-informasi-pajak"].showModal();
    },
    goDaftar() {
      this.$router.push("/bphtb/daftar");
    },
    goObject() {
      this.$refs["modal-objek-pajak"].showModal();
    },
    goDasarHukum() {
      this.$refs["dasar-hukum"].showModal();
    },
    goback() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="scss" scoped>
.section-shaped .shape.shape-skew + .shape-container {
  padding-top: 9rem;
  padding-bottom: 14rem;
}

.card-bphtb {
  height: 100%;
}

.chart-wrapper {
  position: relative;
  padding-bottom: 40%;
}

.chart-inner {
  position: absolute;
  width: 100%;
  height: 100%;
}
</style>